




























































































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import AudienceCreativeCard from '@ui/cards/AudienceCreativeCard'
import AudienceCreativeDisplay from '@ui/AudienceCreative/AudienceCreativeDisplay'
import SuperNotes from '@modules/ui/notes/SuperNotes'

settings =
  name: 'PreviewStep'

  resources:
    spaces:
      resourceName: 'space'
      slug: 'suppliers/:audienceCreative.supplier_id/audience_creatives/:audienceCreative.id/spaces'
      params:
        quick_list: true
      fetch: false

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      AudienceCreativeCard,
      AudienceCreativeDisplay,
      SuperNotes,
    }

    computed:
      audienceCreative: ->
        @wizard.audienceCreativeData

      renamedSegments: ->
        spaces = @spaces || []
        spaces = spaces.filter((space) => space.segment_renamed)
        spaces = spaces.map((space) => space.segment)
        @compact spaces

      isSyncingSegments: ->
        @renamedSegments.length > 0

      draftCount: ->
        @audienceCreative.stats.draft_availabilities_count

      publishedCount: ->
        @audienceCreative.stats.published_availabilities_count

      canPublish: ->
        return false unless @audienceCreative.publishable
        @draftCount > 0

      unpublishableReasons: ->
        mapStepName =
          assets: 'inventory'
        for reason in @audienceCreative.unpublishable_reasons
          stepName = reason.split(/\b/)[0].toLowerCase()
          stepName = mapStepName[stepName] if mapStepName[stepName]
          message: reason
          stepName: stepName

    mounted: ->
      @wizard.fetchAudienceCreative()

    methods:
      hiFinishAndPublish: ->
        @wizard.publishAllTrigger() # publish will close wizard once its done

      hiPublishAll: ->
        @wizard.publishAllTrigger()

      hiUnpublishAll: ->
        @wizard.unpublishAllTrigger()

      hiNavToAdvancedSettings: ->
        @wizard.navToStepName 'advanced-settings'

      hiAddSuperNote: ->
        note = @audienceCreative.new_super_notes[0]
        @wizard.addSuperNote note

export default VueOptions.vue settings
